import React, { Component, Fragment } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

import "../scss/style.scss";

export default function AlertDialog() {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Fragment>
			<Button onClick={handleClickOpen}>Open Dialog</Button>
			<Dialog open={open} onClose={handleClose}>
				<div className="dialog-body">
					<p>코드가 확인되었습니다.</p>
				</div>
				<div className="dialog-footer">
					<button onClick={handleClose} color="primary" autoFocus className="btn btn-primary btn-sm">
						OK
					</button>
				</div>
			</Dialog>
		</Fragment>
	);
}
